export const BASKET_TOKEN_NAME = 'basketToken';
/** from scayle doc https://scayle.dev/en/api-guides/checkout-authentication-api/resources/oauth-client/log-in-users */
export const ACCESS_TOKEN_EXPIRATION = 2678400;
export const SENDER_ID_EXPIRATION = 2678400;
